<template lang="html">
  <div id="header">
    <div v-if="loader" class="loader"></div>
      <div class="col-xs-12 nav">
        <div class="text-left">
          <span class="" @click="showNav"><img class="img-responsive" src="../assets/img/icons/menu-icon.svg" width="640" height="360" alt="Logo"></span>
        </div>
        <div v-if="nav" class="nav-container">
          <div class="hideNav text-left">
            <span @click="hideNav"><img class="img-responsive" src="../assets/img/icons/menu-icon-blue.svg" width="640" height="360" alt="Logo"></span>
          </div>
          <div v-if="homePage" class="links">
            <a href="#services"><span @click="hideNav">{{translation.header.services}}</span></a>
          </div>
          <div class="links">
            <router-link :to="{name:'registered-vets', params:{ lang: lang}}">{{translation.doctor.doctors}}</router-link>
          </div>
          <div class="links">
            <router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link>
          </div>
          <div class="links">
            <router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link>
          </div>
          <div class="links language-mobile">
            <select id="select-language-home" v-model="defaultLang" @change="setLanguage">
              <option class="language-option" v-for="language in languages" :value="language.value">
                {{language.text}}
              </option>
            </select>
          </div>
          <div class="links registration">
            <router-link :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}</router-link>
          </div>
          <div class="links login">
            <router-link :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
          </div>
          <div class="left-paw">
            <img class="img-responsive" src="../assets/img/icons/small-menu-left-paw.svg" alt="Paw">
          </div>
          <div class="right-paw">
            <img class="img-responsive" src="../assets/img/icons/small-menu-right-paw.svg" alt="Paw">
          </div>
          <div class="links center-paw">
            <img class="img-responsive" src="../assets/img/icons/one-paw-mobile.svg" alt="Paw">
          </div>
          <div class="links followUs">
            {{translation.menu.followUs}}
          </div>
          <div class="followUs-icons">
            <div class="row">
              <div class="col-xs-6 fb text-right">
                <a href="https://web.facebook.com/My-Electronic-Pet-Passport-100922267942159" target="_blank"><img class="img-responsive" src="../assets/img/icons/facebook-blue.svg" alt="Facebook"></a>
              </div>
              <div class="col-xs-6 insta text-left">
                <a href="https://www.youtube.com/channel/UCQslSWc0OMv5CabwZ5d8McQ" target="_blank"><img class="img-responsive" src="../assets/img/icons/YouTube_social_dark.svg" alt="YouTube"></a>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="col-md-12 hiden-menu-mobile">
      <div v-if='fixedHeader' id='fixed-header' class="row">
        <div class="col-lg-3 logo text-center">
          <router-link :to="{name:'home', params:{ lang: lang}}"><img class="img-responsive" src="../assets/img/icons/logo.svg" alt="Logo"></router-link>
        </div>
        <div class="col-lg-9">
          <div class="header-menu-links">
            <span v-if="homePage" class="header-links text-left">
              <a href="#services">{{translation.header.services}}</a>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'registered-vets', params:{ lang: lang}}">{{translation.doctor.doctors}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link>
            </span>
            <div class="login-registration-links">
              <span class="header-links text-center login-text">
                <router-link :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
              </span>
              <span class="header-links text-center registration-text">
                <router-link :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}
                </router-link>
              </span>
            </div>
            <div class="language">
              <select id="select-language-home" v-model="defaultLang" @change="setLanguage">
                <option class="language-option" v-for="language in languages" :value="language.value">
                  {{language.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-lg-3 logo text-center">
          <router-link :to="{name:'home', params:{ lang: lang}}"><img class="img-responsive" src="../assets/img/icons/logo-pechat.svg" width="640" height="360" alt="Logo"></router-link>
          <div class="logo-ballon-small">
            <img class="img-responsive" src="../assets/img/icons/logo-ballon.svg" width="640" height="360" alt="Logo">
          </div>
          <div class="mepp-text text-center">
            <div>
              {{translation.header.logoText}}
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="header-menu-links">
            <span v-if="homePage" class="header-links text-left">
              <a href="#services">{{translation.header.services}}</a>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'registered-vets', params:{ lang: lang}}">{{translation.doctor.doctors}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'about-us', params:{ lang: lang}}">{{translation.aboutUs.about}}</router-link>
            </span>
            <span class="header-links text-left">
              <router-link :to="{name:'support', params:{ lang: lang}}">{{translation.header.contacts}}</router-link>
            </span>
            <div class="login-registration-links">
              <span class="header-links text-center login-text">
                <router-link :to="{name:'login', params:{ lang: lang}}">{{translation.header.login}}</router-link>
              </span>
              <span class="header-links text-center registration-text">
                <router-link :to="{name:'registration', params:{ lang: lang}}">{{translation.header.registration}}
                </router-link>
              </span>
            </div>
            <div class="language">
              <select id="select-language-home" v-model="defaultLang" @change="setLanguage">
                <option class="language-option" v-for="language in languages" :value="language.value">
                  {{language.text}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      translation: null,
      loader: false,
      user: [],
      nav: false,
      fixedHeader: false,
      pets:'',
      doctor: [],
      languages: message.flags.flag,
      lang: window.lang,
      defaultLang: '',
      homePage: false,
      windowWidth: window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth
    }
  },
  created(){
    if (localStorage.getItem('language')) {
      this.defaultLang = localStorage.getItem('language');
    }else {
      this.defaultLang = 'bg_BG';
    }
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    if (this.$route.name == 'home') {
      this.homePage = true;
    }
  },
  mounted() {
    if (this.windowWidth > 600){
      document.addEventListener('scroll', this.handleScroll)
    }

  },
  destroyed () {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll: function () {
      var navbar = document.getElementById("header");
      var sticky = '500';
        if (window.pageYOffset >= sticky) {
          this.fixedHeader = true;
        } else {
          this.fixedHeader = false;
        }
    },
    showNav: function(e){
      this.nav = true;
    },
    hideNav: function(e){
      this.nav = false;
    },
    setLanguage: function(){
      localStorage.setItem('language', this.defaultLang);
      this.$bus.$emit('language',true)
      this.lang = window.lang;
    }
  }
}
</script>

<style>
  @font-face {
    font-family: 'Montserrat-Bold';
    src: url("../assets/fonts/Montserrat-Bold.woff") format("woff");
    font-display: swap;
  }
  .fixedHeader{
    display: block;
  }
  #header {
    width: 100%;
    background: #FFF;
    background-image: url("../assets/img/backgrounds/hedyr.webp");
    height: 45em;
    background-size: 100% auto;
    background-repeat:no-repeat;
    position: relative;
    font-size: 20px;
  }
  #header {
    font-family: 'Montserrat-Bold', sans-serif;
  }
  #header #fixed-header a{
    color: #3057B0;
  }
  #header .thumb {
    display: block;
  }
  #header .notifications{
    width: 2em;
    height: 2em;
    margin-top: 1em;
    padding: 6px;

  }
  #header .logo{
    list-style: none;
  }
  #header .logo img{
    width: 15em;
  }
  #header .logo a{
    display: inline-block;
    text-align: right;
  }
  #services{
    padding-top: 6em;
  }
select option{
  padding-left: 64px;
  background-repeat: no-repeat;
  }
  #header .header-menu-links span{
    display: inline-block;
    margin-right: 1em;
    margin-top: 1em;
  }
 #header #fixed-header span{
      display: inline-block;
    margin-top: 1.5em;
  }
  #header .login-registration-links {
    display: inline-block;
    margin-left: 4em;
    color: #fff;
  }
  #header .header-menu-links a{
    color: #fff;
  }
  #header .header-menu-links a:hover{
    color: #FED154;
    text-decoration: none;

  }
  #header .registration-text a{
    color: #3057B0;
  }
  #header .registration-text{
    background: #FDD84C;
    border: 2px solid #FDD84C;
    padding: .3em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    border-radius: 5em;
  }
  #header .registration-text a:hover{
    color: #FFF;
  }
  #header .login-text a {
    padding: .4em;
    padding-left: 1.5em;
    padding-right: 1.5em;
    border-radius: 5em;
    border: 2px solid #FFF;
    color: #FFFFFF;
  }
  #header .nav{
    display: none;
  }
  #header .logo-ballon-small{
    position: absolute;
    top: 8em;
    left: 15em;
    width: 7em;
  }
  #header .language {
    display: inline-block!important;
  }
  #header .language:hover {
    cursor: pointer!important;
  }
  #header .language select,
  #header .language-mobile select{
    background: #3057B0!important;
    border: none!important;
    background: none!important;
    border-radius: 5em!important;
    padding: 5px!important;
    color: #FDD84C!important;
    font-family: 'Montserrat-Bold', sans-serif!important;
    border: none!important;
    outline: none!important;
    scroll-behavior: smooth!important;
  }
  #header .language-option {
    color: #3057B0!important;
    background-color: #FDD84C!important;
  }
  #header .language-mobile select{
    background: #3057B0!important;
    color: #FFFFFF!important;
  }
  #header .language-option{
    color:#3057B0!important;
    background-color: #FDD84C!important;
  }
  #header .language select::-ms-expand,
  #header .language-mobile select::-ms-expand {
      display: none!important;
  }
  #header .language select,
  #header .language-mobile select{
      -webkit-appearance: none!important;
      appearance: none!important;
  }
  #header {
    position: relative;
  }
  #header .mepp-text {
    position: absolute;
    right: 0;
    left: 10em;
    margin-top: 7em;
    color: #fff;
    text-align: center;
    text-shadow: 1px 1px 1px #000;
  }
  .nav-container{
    position: fixed;
    width: 100%;
    max-height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 999;
    overflow-y: scroll;
  }
  @font-face {
    font-family: 'Montserrat-Black';
    src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
    font-display: swap;
  }
  #header .links{
    margin-bottom: 2em;
    text-align: center;
    font-family: 'Montserrat-Black', sans-serif;
  }
  #header .links a{
    color: #3057B0;
  }
  #header #fixed-header{
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #FFFFFF!important;
    height: 100px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
    left: 0;
  }
  #fixed-header .logo img{
    width: 10em;
    margin-top: 1em;
  }
  @media (max-width: 1590px) {
    #header {
      font-size: 16px;
    }
  }
  @media (max-width: 1224px) {
    #header {
      font-size: 16px;
    }
    #header .hiden-menu-mobile{
      display: none;
    }
    #header .nav{
      display: block;
      padding: 15px;
    }
    .nav img {
      width: 8em;
    }
    .followUs-icons img{
      max-width: 5em;
    }
    #header .right-paw,
    #header .left-paw,
    #header .center-paw{
      display: none;
    }
    .followUs{
      color: #3057B0;
    }
    .followUs-icons .col-xs-6 {
      position: relative;
    }
    #header .registration{
      background-color: #3057B0;
      border-radius: 5em;
      padding: 5px;
      width: 70%;
      margin: 0 auto;
      margin-bottom: 2em;
    }
    #header .registration a{
      color: #FDD84C;
    }
    #header .login{
      border-radius: 5em;
      padding: 5px;
      width: 50%;
      margin: 0 auto;
      border: 2px solid #3057B0;
      margin-bottom: 2em;
    }
  }
  @media (max-width: 1024px) {

  }
  @media (max-width: 768px) {
    .nav img {
      width: 5em;
    }
    .followUs{
      margin-top: 2em;
      color: #3057B0;
    }
    .followUs-icons img{
      width: 4em;
      padding: .5em;
    }
    #header .language{
      display: none;
    }
    .logo {
      margin: 0 auto;
    }
    #header span img {
      width: 5em;
    }
    .hideNav{
      padding: 15px;
    }
    #header .links{
      margin-bottom: 1em;
    }
    #header .back img{
      width: 4.8em;
    }
    #header .right-paw{
      position: absolute;
      right: 0;
      top: 7em;
    }
    #header .left-paw{
      position: absolute;
      left: 0;
      top: 14em;
    }
    #header{
      background-image: url('../assets/img/backgrounds/01-home-–-35.jpg');
    }
   }
   @media (max-width: 600px) {
     .logo{
       margin-left: 1em;
     }

     #header .center-paw {
       bottom: 28%;
     }
   }
</style>
